import { BossCallout } from 'modules/boss';
import { Navbar } from 'modules/nav';
import { NavbarVariant } from 'modules/nav/types';
import styled from 'styled-components';

const Container = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
`;

export const Header = ({ variant }: { variant?: NavbarVariant }) => {
  return (
    <Container data-test="sticky-nav">
      <BossCallout />
      <Navbar variant={variant} />
    </Container>
  );
};
